import React from 'react';
import classNames from 'classnames';
import styles from './assets/incentive-form.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from 'src/components/react-table/Grid';
import textFilter from 'src/components/react-table/filters/text-filter';
import { CellProps } from 'react-table';

import PrlProviderActionsColumn from './PrlProviderActionsColumn';
//import ProviderCellColumn from './ProviderCellColumn';

import ProviderDetailColumn from '../../Providers/screens/ProviderList/components/ProviderDetailColumn';
import { IProvider } from 'src/types/provider';

interface Props {
    data: Paginated<IProvider>;

    stateData: any;
    //    inProgressProvider: boolean;
    setStateData: (data: any) => void;
}

const getColumns = (
    providers: any,
    data: any,
    setData: any,
    selectAll: boolean,
    setSelectAll: (value: boolean) => void,
): Column<IProvider>[] => [
    {
        Header: () => (
            <div>
                <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={(e) => {
                        const checked = e.target.checked;
                        setSelectAll(checked);
                        const updatedData = { ...data };
                        Object.keys(providers?.list).forEach((key) => {
                            updatedData[providers?.list[key]?.id] = {
                                ...providers?.list[key],
                                action: checked,
                            };
                        });
                        setData(updatedData);
                    }}
                />
                <span style={{ marginLeft: 8 }}></span>
            </div>
        ),
        accessor: 'staffTitle',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IProvider>) => <PrlProviderActionsColumn original={original} data={data} setData={setData} />,
        disableSortBy: true,
        disableFilters: true,
        width: '10%',
    },
    {
        Header: '#',
        accessor: 'id', //occasion
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IProvider>) => original?.id,
        Filter: textFilter<IProvider>(),
    },

    {
        Header: 'Full Name',
        accessor: 'fullName',
        disableSortBy: true,
        disableFilters: true,
        Cell: ProviderDetailColumn,
        Filter: textFilter<IProvider>(),
    },
];

const ProvidersProviderGrid: React.FunctionComponent<Props> = ({
    data,

    stateData,
    setStateData,
}: Props) => {
    const [selectAll, setSelectAll] = React.useState(false);
    const columnData: Column<IProvider>[] = getColumns(data, stateData, setStateData, selectAll, setSelectAll);

    return (
        <div className={classNames(styles.grid)}>
            <Grid<IProvider> noDots={true} noLoader={true} columns={columnData} data={data} getData={() => false} />
        </div>
    );
};

export default ProvidersProviderGrid;
